import DapDSSkipLink from './skip-link.component'

export * from './skip-link.component'
export default DapDSSkipLink

DapDSSkipLink.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-skip-link': DapDSSkipLink
  }
}
